export const currentBarringInitialState = {
  data: {
    barringId: "",
    barringItemList: [],
    barringName: "",
    customerId: "",
    destinationId: "",
    destinationType: "",
    regoleDiApplicazione: "",
  },
  loading: false,
};

export const createBarringDataInitialState = {
  data: {
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    fileAudioList: [],
    originAreaList: [],
    currentItemList: [],
  },
  loading: false,
};
